import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const useTestQuestionsList = (params?: { testId?: string; pageNumber?: number; pageSize?: number }) => {
  return useQuery({
    queryKey: ['test-questions-list', params],
    queryFn: async () => {
      const res = await request.get('/test/questions', { params });
      return res.data;
    },
    enabled: !!params?.testId
  });
};
